module.exports = __webpack_public_path__ + "img/complect.d072043.svg";